import AppRoot from './app/AppRoot';

export default AppRoot;
